export const  UserRoutes = {
   
    getUsers: "/users",
    getDesigns:"/users/designs",
    updateUser:"/users/updateProfile",
    getMerchants:'vendors',
    getBlogs:'/blogs'
    
  };
    